<template>
    <rkm-modal
        :title="`Fichas - ${item ? item.funcionalidade : ''}`"
        extraLarge
        ref="Modal"
    >
        <rkm-alert v-if="profissional">
            <strong>Profissional: </strong> {{ profissional.nome }} -
            <strong>Equipe: </strong> {{ profissional.equipeDescricao }} <br>
            <strong>Unidade: </strong> {{ profissional.unidade }} -
            <strong>Local de atendimento: </strong> {{ profissional.localAtendimento }}
        </rkm-alert>

        <rkm-table
            :fields="fields"
            :items="items"
            sort-by="data"
        />

        <template v-slot:footer="{ cancel }">
            <rkm-button @click="cancel">Fechar</rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import { repository, stringCase, data, object, formats, error } from '@/mixins'

// Vuex.
import { mapActions } from "vuex"

export default {
    created() {
        this.repositories = {
            exportacao: this.getConectaSusRepository('atencaoBasica.exportacao')
        }
    },
    computed: {
        fields() {
            if (this.item && this.item.funcionalidade == 'Cadastro domiciliar e territorial') {
                return [
                    {
                        key: "data",
                        label: "Data do atendimento",
                        class: "col-min text-center",
                        sortable: true,
                        searchable: true,
                    },
                    {
                        key: "logradouroTipoDescricao",
                        label: "Tipo logradouro",
                        sortable: true,
                        searchable: true,
                    },
                    {
                        key: "logradouroNome",
                        label: "Logradouro",
                        sortable: true,
                        searchable: true,
                    },
                    {
                        key: "enderecoNumero",
                        label: "Número",
                        sortable: true,
                        searchable: true,
                    },
                    {
                        key: "bairro",
                        label: "Bairro",
                        sortable: true,
                        searchable: true,
                    },
                    {
                        key: "logradouroCep",
                        label: "CEP",
                        class: "col-min text-center",
                        sortable: true,
                        searchable: true,
                    },
                    {
                        key: "loteamentoNome",
                        label: "Loteamento / Subdistrito",
                        sortable: true,
                        searchable: true,
                    },
                    {
                        key: "enderecoComplemento",
                        label: "Complemento",
                        sortable: true,
                        searchable: true,
                    },
                ]
            }
            else if (this.item && this.item.funcionalidade == 'Atividade coletiva') {
                return [
                    {
                        key: "data",
                        label: "Data do atendimento",
                        class: "col-min text-center",
                        sortable: true,
                        searchable: true,
                    },
                    {
                        key: "profissionalResponsavel",
                        label: "Profissional",
                        sortable: true,
                        searchable: true,
                    },
                    {
                        key: "localAtividade",
                        label: "Local",
                        sortable: true,
                        searchable: true,
                    },
                    {
                        key: "atividadeTipo",
                        label: "Atividade",
                        sortable: true,
                        searchable: true,
                    },
                    {
                        key: "saudeTemas",
                        label: "Tema",
                        sortable: true,
                        searchable: true,
                    },
                    {
                        key: "totalParticipantes",
                        label: "Participantes",
                        class: "col-min text-center",
                        sortable: true,
                        searchable: true,
                    },
                ]
            }
            else {
                return [
                    {
                        key: "data",
                        label: "Data do atendimento",
                        class: "col-min text-center",
                        sortable: true,
                        searchable: true,
                    },
                    {
                        key: "pacienteNome",
                        label: "Paciente",
                        sortable: true,
                        searchable: true,
                    },
                    {
                        key: "pacienteProntuario",
                        label: "Prontuário",
                        class: "col-min text-center",
                        sortable: true,
                        searchable: true,
                    },
                ]
            }
        },
    },
    data() {
        return {
            edit: false,
            id: null,
            item: null,
            items: [],
            profissional: null,
        }
    },
    methods: {
        ...mapActions(["setLoading", "unsetLoading"]),
        open(item) {
            this.item = item
            this.items = []
            this.profissional = null

            this.setLoading()

            this.repositories.exportacao.getFichas(this.prepareData(item))
                .then(({ data }) => {
                    this.items = data.fichas
                    this.profissional = data.profissional
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading());

            this.$refs.Modal.show()
        },
        prepareData(item) {
            const uuid = item.uuid
            const funcionalidade = item.funcionalidade

            return this.camelObjectKeysToSnakeRecursive({
                uuid, funcionalidade
            })
        },
    },
    mixins: [repository, stringCase, data, object, formats, error],
}
</script>